import { Injectable } from '@angular/core';
import { BillingCtAttachedFile } from 'src/app/model/billing/billing-ct-attached-file';
import { DataService } from '../data.service';

@Injectable({
  providedIn: 'root'
})
export class BillingOrderControlCTAttachedFileService {

  constructor( private dataService: DataService) {
  }

  private readonly getCTAttachedFilesEndPoint: string = '/billingOrderControlCTAttachedFile/getCTAttachedFiles/';
  private readonly getBase64CTAttachedFileEndPoint: string = '/billingOrderControlCTAttachedFile/getBase64CTAttachedFile/';

  async getCTAttachedFiles( medicalAppointmentId: number): Promise<BillingCtAttachedFile[]> {
    const params = { medicalAppointmentId };
    return await this.dataService
                     .get<BillingCtAttachedFile[]>(this.getCTAttachedFilesEndPoint, params)
                     .toPromise();
  }

  async getBase64CTAttachedFile( cTAttachedFileId: string): Promise<BillingCtAttachedFile> {
    const params = { cTAttachedFileId };
    return await this.dataService
                     .get<BillingCtAttachedFile>(this.getBase64CTAttachedFileEndPoint, params)
                     .toPromise();
  }
}
